module.exports = __webpack_public_path__ + "img/icon-error-book.9fc1efb9.png";